import React, { useState, useEffect } from 'react';
import { getAuth, updateProfile, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './ProfilePage.css'; 

function ProfilePage() {
  const auth = getAuth();
  const user = auth.currentUser;
  const navigate = useNavigate();

  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Placeholder for Role Logic. 
  // In the future, we can fetch this from a Firestore 'Users' collection.
  const userRole = "Administrator"; 

  useEffect(() => {
    if (user) {
      setDisplayName(user.displayName || '');
      setEmail(user.email || '');
    }
  }, [user]);

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    try {
      if (user.displayName !== displayName) {
        await updateProfile(user, { displayName: displayName });
        setMessage('Profile updated successfully.');
      } else {
        setMessage('No changes to save.');
      }
    } catch (err) {
      console.error("Error updating profile:", err);
      setError('Failed to update profile. Please try again.');
    }
    setLoading(false);
  };

  const handlePasswordReset = async () => {
    if (!email) return;
    setMessage('');
    setError('');
    
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage(`Password reset email sent to ${email}`);
    } catch (err) {
      console.error("Error sending reset email:", err);
      setError('Failed to send password reset email.');
    }
  };

  return (
    <div className="profile-page-container">
      
      {/* Header Section with Navigation */}
      <div className="profile-header-row">
        <div className="header-text">
          <h2>My Profile</h2>
          <p>Manage your account settings and preferences.</p>
        </div>
        <button className="btn btn-secondary" onClick={() => navigate('/dashboard')}>
          Go to Dashboard
        </button>
      </div>

      {/* Centered Content Card */}
      <div className="profile-card">
        
        {/* User Info / Role Header */}
        <div className="profile-identity">
          <div className="profile-avatar">
            {displayName ? displayName.charAt(0).toUpperCase() : 'U'}
          </div>
          <div className="identity-text">
            <h3>{displayName || 'User'}</h3>
            <span className={`role-badge ${userRole === 'Administrator' ? 'badge-admin' : 'badge-contributor'}`}>
              {userRole}
            </span>
          </div>
        </div>

        <hr className="divider" />

        {/* Feedback Messages */}
        {message && <div className="alert alert-success">{message}</div>}
        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleUpdateProfile} className="profile-form">
          
          <div className="form-group">
            <label>Display Name</label>
            <input
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              placeholder="Enter your name"
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              disabled
              className="input-disabled"
            />
            <small>Email cannot be changed directly.</small>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
            <button type="button" className="btn btn-outline" onClick={handlePasswordReset}>
              Reset Password
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default ProfilePage;